import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

interface SeasonSwitchModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  seasonName: string;
  employeeName: string;
}

const SeasonSwitchModal: FC<SeasonSwitchModalProps> = ({
  open,
  onClose,
  onConfirm,
  seasonName,
  employeeName,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{t('seasonSwitch.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('seasonSwitch.description', {
            employeeName,
            seasonName,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary' variant='outlined'>
          {t('dialog.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color='primary'
          variant='contained'
          endIcon={<SwapHorizIcon />}
        >
          {t('seasonSwitch.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SeasonSwitchModal;
